<script>
export default {
    beforeRouteEnter(_, __, next) {
        next({ path: '/?utm_source=exchange&utm_medium=referral&utm_campaign=coincheck_app', replace: true });
    },
    layout: 'unAuthOnlyEmpty',
};
</script>
